export enum ReportTypesEnum {
  ImpactSummary,
  AchievementSummary,
  StudentGradebookReport,
  StudentAchievementSummary,
}
